import React from 'react'
import { ReadProfile } from 'src/component/profile/personal-info/profile/read-profile'

export const Profile = (): React.ReactElement => {
  return <ReadProfile />
}
